const ID_TOKEN_KEY = "id_token";

export const getToken = () => {
  try {
    if(window.localStorage && window.localStorage.getItem(ID_TOKEN_KEY) !== null){
      return window.localStorage.getItem(ID_TOKEN_KEY);
    }
  } catch (error) {
    console.log(error)
  }
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = token => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
  try {
    if(window.localStorage && window.localStorage.getItem(ID_TOKEN_KEY) !== null){
      window.localStorage.removeItem(ID_TOKEN_KEY);
    }
  } catch (error) {
    console.log(error)
  }
};

export default { getToken, saveToken, destroyToken };
